import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import FlashSaleBanner from "../components/FlashSaleBanner";
import { fetchProducts, fetchCategories } from "../lib/api";
import { motion } from "framer-motion";

export default function Shop() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCategory = searchParams.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories().then(setCategories).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const cat = activeCategory === "all" ? undefined : activeCategory;
    fetchProducts(cat)
      .then(setProducts)
      .finally(() => setLoading(false));
  }, [activeCategory]);

  const setCategory = (slug) => {
    if (slug === "all") setSearchParams({});
    else setSearchParams({ category: slug });
  };

  return (
    <div className="pt-24 pb-24 min-h-screen" data-testid="shop-page">
      <FlashSaleBanner />
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <div className="label-eyebrow mb-4">Shop the Collection</div>
          <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-none">
            The complete <span className="italic text-gradient-gold">BananaX</span> collection.
          </h1>
        </motion.div>

        {/* Category filter */}
        <div className="flex flex-wrap gap-2 mb-16 border-b border-white/10 pb-6" data-testid="shop-category-filter">
          <button
            onClick={() => setCategory("all")}
            data-testid="category-filter-all"
            className={`text-[11px] tracking-[0.22em] uppercase px-4 py-2 border transition-colors ${
              activeCategory === "all"
                ? "border-gold text-gold"
                : "border-white/10 text-mist hover:border-gold hover:text-gold"
            }`}
          >
            All
          </button>
          {categories.map((c) => (
            <button
              key={c.slug}
              onClick={() => setCategory(c.slug)}
              data-testid={`category-filter-${c.slug}`}
              className={`text-[11px] tracking-[0.22em] uppercase px-4 py-2 border transition-colors ${
                activeCategory === c.slug
                  ? "border-gold text-gold"
                  : "border-white/10 text-mist hover:border-gold hover:text-gold"
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="aspect-[4/5] bg-ink-900 animate-pulse"></div>
            ))}
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-20" data-testid="shop-product-grid">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
